import React from 'react';
import { Alert, Button, Grid, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { GrowConnectCard } from './GrowConnectCard';

type GrowConnectApprovedProps = {
  /** Grow approved the business but the account is not charging through Grow yet. */
  isConnected: boolean;
};

/**
 * Reads equally well as a live transition and as something discovered on a Monday morning --
 * approval lands via a webhook, so most merchants will meet this screen on a cold page load.
 *
 * Deliberately does not surface the Grow form link: it stays valid after approval, and nobody
 * should be able to click back into a registration they have already completed.
 */
export const GrowConnectApproved = ({ isConnected }: GrowConnectApprovedProps) => {
  const { t } = useTranslation();

  if (!isConnected) {
    return (
      <GrowConnectCard title={t('growConnect.approvedNotConnected.title')}>
        <Alert severity="warning">{t('growConnect.approvedNotConnected.body')}</Alert>
      </GrowConnectCard>
    );
  }

  return (
    <GrowConnectCard title={t('growConnect.connected.title')} titleIcon={<CheckCircle color="success" />}>
      <Typography textAlign="center">{t('growConnect.connected.body')}</Typography>
      <Grid container justifyContent="center">
        <Button variant="contained" component={Link} to="/dashboard/storefronts">
          {t('growConnect.connected.storefrontsCta')}
        </Button>
      </Grid>
    </GrowConnectCard>
  );
};
